import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              热门连载每日更新，追更不等待
            </p>
          </div>
          <Link
            to="/category/shaonian-rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  title={`${comic.title} - 免费阅读下拉式漫画 - 布丁漫画网`}
                />
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span>{comic.author}</span>
                <div className="flex items-center gap-1">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500"></i>
                  </div>
                  <span>{comic.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}